import * as StoreTypes from "./DataTypes/storeTypes";

export function getDefaultState(settings: StoreTypes.IInitialSettings): StoreTypes.IStore {
    const data: StoreTypes.IStore = {
        initialSettings: {
            ...settings,
        },

        common: {
            state: StoreTypes.State.None,
            isBusy: false,
            recoverPageState: StoreTypes.TokenState.Initial,
            registerPageState: StoreTypes.TokenState.Initial,
            setExistingClientCredentialsPageState: StoreTypes.TokenState.Initial,
            clientName: settings.clientName,
        },
        forms: {
            loginForm: {},
            recoverForm: {},
            createForm: {},
            setExistingClientCredentialsForm: {},
        },
    };

    return data;
}
